/* eslint-disable */
import { withStyles } from '@material-ui/core/styles';
import withWidth from '@material-ui/core/withWidth';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators, compose } from 'redux';
import DocketsListComponent from '../../Components/DocketsList/DocketsList.component';
import withEntries from '../../Contexts/Entries/WithEntries.context';
import withServices from '../../Contexts/Services/WithServices.context';
import sidebarActionCreators from '../../State/Store/Sidebar/Sidebar.actions';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import PageSingleColumn from '../Layouts/PageSingleColumn';
import './Dockets.page.i18n';
import DocketsPagePropTypes from './Dockets.page.props';
import DocketsPageStyles from './Dockets.page.styles';

/**
 * DocketsPageComponent
 * @export
 * @class DocketsPageComponent
 * @extends {React.Component<DocketsPageComponentComposedProps, DocketsPageComponentState>}
 */
export class DocketsPageComponent extends React.Component {
  /**
   * The `props` to seed when any specific prop receives an `undefined` value. **NOT** a `null` value
   * @static
   * @type {Partial<DocketsPageComponentProps>}
   * @memberof DocketsPageComponent
   */
  static defaultProps = {};

  /**
   * The name of the Component to display when debugging
   * @static
   * @type {`DocketsPage`}
   * @memberof DocketsPageComponent
   */
  static displayName = `DocketsPage`;

  static propTypes = DocketsPagePropTypes;

  /**
   * Data specific to the `<DocketsPage />` instance
   * @type {DocketsPageComponentState}
   * @memberof DocketsPageComponent
   */
  state = {};

  /**
   * Render the component
   * @returns {React.Component} The rendered `<DocketsPage />`
   * @memberof DocketsPageComponent
   */
  render() {
    return (
      <PageSingleColumn defaultLanguageHeading="Dockets" englishTitle="Dockets" overflowY="hidden" title="Dockets">
        <DocketsListComponent />
      </PageSingleColumn>
    );
  }
}

/** @type {React.ComponentClass<DocketsPageComponentProps>} */
const DocketsPage = compose(
  withEntries,
  withRouter,
  withServices,
  withWidth(),
  withStyles(themeCreateInjectableStyles(DocketsPageStyles), { withTheme: true }),
  connect(
    null,
    (dispatch) => ({
      actions: bindActionCreators(
        {
          ...sidebarActionCreators,
        },
        dispatch,
      ),
    }),
  ),
)(DocketsPageComponent);

export default DocketsPage;
